import { render, staticRenderFns } from "./PolicyItemText.vue?vue&type=template&id=2a4f2f5f&scoped=true&"
import script from "./PolicyItemText.vue?vue&type=script&lang=js&"
export * from "./PolicyItemText.vue?vue&type=script&lang=js&"
import style0 from "./PolicyItemText.vue?vue&type=style&index=0&id=2a4f2f5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f2f5f",
  null
  
)

export default component.exports